import { Button, Row, Col } from 'antd';

interface ButtonListFooterProps {
  handleSave: (() => void) | (() => Promise<void>);
  handleSend: (() => void) | (() => Promise<void>);
  isLoading?: boolean;
  hideSendBtn?: boolean;
  isDisabled?: boolean;
  isSaveBtnDisabled?: boolean;
  isSendBtnDisabled?: boolean;
  isAdminRole?: boolean;
}

export const ButtonListFooter = ({
  handleSave,
  handleSend,
  isLoading,
  hideSendBtn,
  isDisabled,
  isSaveBtnDisabled,
  isSendBtnDisabled,
  isAdminRole = false,
}: ButtonListFooterProps) => (
  <>
    <Row
      style={{
        justifyContent: 'space-around',
        justifyItems: 'center',
        width: '400px',
      }}
    >
      <Button
        key='save'
        type={'primary'}
        onClick={handleSave}
        loading={isLoading}
        disabled={isDisabled || isSaveBtnDisabled}
      >
        Save
      </Button>
      <Button
        key='send'
        type={!isAdminRole ? 'primary' : undefined}
        onClick={handleSend}
        loading={isLoading}
        style={{ display: hideSendBtn && !isAdminRole ? 'none' : 'block' }}
        disabled={!isAdminRole && (isDisabled || isSendBtnDisabled)}
      >
        {!isAdminRole ? 'Send' : 'Cancel'}
      </Button>
    </Row>
  </>
);

export const ButtonListHeader = (createModalShow: () => void) => (
  <Button type='primary' onClick={createModalShow}>
    Create new
  </Button>
);

export const ButtonListFooterModalSM = (handleSave: () => void, handleCancel: () => void, isLoading?: boolean) => [
  <Button key='save' type='primary' onClick={handleSave} loading={isLoading} className='smartFooterButtonXS'>
    Save
  </Button>,
  <Button key='send' onClick={handleCancel} loading={isLoading}>
    Cancel
  </Button>,
];

export const ButtonListFooterWithDeleteModalSM = (
  handleSave: () => void,
  handleCancel: () => void,
  onClickDelete: () => void,
  isLoading?: boolean,
  hideDeleteBtn?: boolean,
) => (
  <Col style={{ display: 'flex', flexDirection: 'column', width: '70%' }}>
    <Row style={{ display: 'flex', justifyContent: 'space-around' }}>
      {ButtonListFooterModalSM(handleSave, handleCancel, isLoading)}
    </Row>
    {hideDeleteBtn ? (
      <></>
    ) : (
      <Row style={{ display: "flex", justifyContent: "center" }}>
        <Button
          type="link"
          style={{ color: "red" }}
          size="small"
          onClick={onClickDelete}
        >
          Delete
        </Button>
      </Row>
    )}
  </Col>
);
